import { createCrudPages, createLazyPage, generateApiRoutes, wrapElement } from "./utils.js";

const clientPages = createCrudPages("clientsPage", "Clients");
const quotePages = createCrudPages("QuotePage", "Quote");
const servicePages = createCrudPages("ServicesPage", "Services");
const projectPages = createCrudPages("ProjectsPages", "Projects");
const CreateTemplateComponent = createLazyPage("ProjectsPages", "CreateTemplate");
const CreateVendorsComponent = createLazyPage("VandorsPage", "CreateVendors");

export const authRoutes = [
	...generateApiRoutes("clients", [
		clientPages.Index,
		clientPages.Show,
		clientPages.Create,
		clientPages.Edit,
	]),
	...generateApiRoutes("quotes", [
		quotePages.Index,
		quotePages.Show,
		quotePages.Create,
		quotePages.Edit,
	]),
	...generateApiRoutes("services", [
		servicePages.Index,
		servicePages.Show,
		servicePages.Create,
		servicePages.Edit,
	]),

	...generateApiRoutes("projects", [
		projectPages.Index,
		projectPages.Show,
		projectPages.Create,
		projectPages.Edit,
	]),
	{
		path: "/projects/create/template",
		element: wrapElement(CreateTemplateComponent, true),
		enabled: true,
	},
	{
		path: "/vendors/create",
		element: wrapElement(CreateVendorsComponent, true),
		enabled: true,
	},
];
